<template>
    <div class="flex flex-col items-center w-full h-full bg-tethys-1 overflow-hidden" autocomplete="off">
        <!-- Search input section -->
        <!-- <div
            class="search-banner w-full bg-cover bg-no-repeat min-h-64 lg:min-h-[350px] bg-[position:50%_50%] relative before:absolute before:top-0 before:left-0 before:w-full before:h-4 before:bg-gradient-to-b before:from-black before:to-transparent before:opacity-20 after:absolute after:bottom-0 after:left-0 after:w-full after:h-4 after:bg-gradient-to-t after:from-black after:to-transparent after:opacity-20">
            <vs-input v-bind:placeholder="$t('enter_your_search_term')" @search-change="onSearch"></vs-input>
        </div> -->

        <!-- Search input section -->
        <!-- <div class="search-banner w-full bg-[length:145%] bg-no-repeat min-h-64 lg:min-h-[475px] bg-[position:50%_50%] relative before:absolute before:top-0 before:left-0 before:w-full before:h-4 before:bg-gradient-to-b before:from-black 
            before:to-transparent before:opacity-20 after:absolute after:bottom-0 after:left-0 after:w-full after:h-4 after:bg-gradient-to-t after:from-black after:to-transparent after:opacity-20">
            <vs-input v-bind:placeholder="$t('enter_your_search_term')" @search-change="onSearch"></vs-input>
        </div> -->


        <!-- <vs-input 
            v-bind:placeholder="$t('enter_your_search_term')" @search-change="onSearch" 
        /> -->

        <section class="w-full px-4 pt-8 2xl:pt-16 pb-32 bg-white text-center">
            <!-- <div class="w-10/12 xl:w-5/6 2xl:w-4/6 mx-auto"> -->
            <div class="w-[85vw] sm:w-[75vw] 2xl:w-[67vw] mx-auto">
                <!-- Title -->
                <h2 class="text-xl md:text-2xl font-bold text-tethys-blue1-dark mb-4">
                    {{ $t('home_title') }}
                </h2>

                <!-- Subtitle -->
                <p class="text-gray-500 text-sm md:text-base mx-auto mb-10 leading-relaxed">
                    {{ $t('home_subtitle') }}
                </p>

                <!-- Feature grid -->
                <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">

                    <div v-for="(card, index) in cards" :key="index"
                        class="group h-[320px] 2xl:h-[350px] bg-gray-50 rounded-xl shadow-sm py-6 px-4 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
                        <div
                            class="w-16 h-16 mx-auto mb-3 flex items-center justify-center bg-tethys-blue1-light group-hover:bg-blue-200 rounded-full text-tethys-blue1-dark text-xl 3xl:text-2xl group-hover:text-2xl 3xl:group-hover:text-3xl">
                            <i :class="card.icon"></i>
                        </div>
                        <h3
                            class="font-semibold text-gray-700 group-hover:text-tethys-blue1-dark 3xl:group-hover:text-lg mb-1"
                        >
                            {{ $t(`cards.${card.key}.title`) }}
                        </h3>
                        <p class="text-sm text-gray-500 transition-all duration-300">
                            <span class="inline group-hover:hidden">
                                {{ $t(`cards.${card.key}.description_default`) }}
                            </span>
                            <span class="hidden group-hover:inline">
                                {{ $t(`cards.${card.key}.description_hover`) }}
                            </span>
                        </p>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script lang="ts">
import HomeViewComponent from "./home-view-component";
export default HomeViewComponent;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./home-view-component.scss";

// .search-banner {
//     // background-image: url('/src/assets/site/img/main-search-banner.jpg');
//     background-image: url('/src/assets/site/img/hero_image_static3.png');
// }
</style>
